/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money';
import Vue from 'vue';

import { payStatusRender } from '@/page/settlementCenter/utils';

// 结算总价列表 带入了相关接口与参数： 部分/已支付/失效
export { projectPriceHanderl } from '@/page/settlementCenter/common/tableConfig/fields';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  partA: {
    label: '合同甲方',
    prop: 'sendName'
  },
  partB: {
    label: '合同乙方',
    prop: 'receiveName'
  },
  feeType: {
    label: '费用类别',
    prop: 'costType',
    formatter: v => {
      return {
        1: '实名认证费',
        2: '合同签约费'
      }[v.costType];
    }
  },
  signType: {
    label: '合同类别',
    prop: 'contractType',
    formatter: v => {
      return (
        {
          1: '平台框架协议',
          2: '乙方供应商',
          3: '供应商C端用户',
          4: '甲方乙方结算单'
        }[v.contractType] || '-'
      );
    }
  },
  signDt: {
    label: '签约时间',
    prop: 'createDt',
    formatter(row, ctx, v) {
      return Vue.filter('transAllTime')(v);
    }
  },
  amount: {
    label: '金额',
    prop: 'price',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  finishDt: {
    label: '结算月度',
    prop: 'taskDt'
  },
  certificationServiceFee: {
    label: '认证信息服务费',
    prop: 'orderPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  finishPayPrice: {
    label: '本次需打款总金额',
    prop: 'orderPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  finishSumTaskPrice: {
    label: '终端结算总金额',
    prop: 'finishSumTaskPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  tax: {
    label: '增值税率',
    prop: 'commission',
    formatter(r, c, v) {
      if (!r.supplierName) {
        return '-';
      }
      return (v / 100).toFixed(2) + '%';
    }
  },
  commission: {
    label: '平台服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      if (!r.supplierName) {
        return '-';
      }
      return (v / 100).toFixed(2) + '%';
    }
  },
  totalPrice: {
    label: '平台服务费',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    render: (h, ctx, r) => {
      return (
        <div>
          <span>{payStatusRender(r, null)}</span>
        </div>
      );
    }
  }
};
